import styled from "styled-components";

export const Button = styled.button`
  font-family: "Work_Sans700";
  width: 326px;
  height: 40px;
  border: 1px solid;
  border-color: #34378b;
  border-radius: 25px;
  margin-bottom: 20px;
  :hover {
    transform: scale(1.04);
    cursor: pointer;
  }
`;
